const NATIVE_CAPTURE_ACTIVE_KEY = "__eweadnNativeCaptureActive";
const LAST_START_CAPTURE_SENT_AT_KEY = "__eweadnLastStartCaptureSentAt";

export function readRhythmNativeCaptureActive(): boolean {
  try {
    return Boolean((window as any)[NATIVE_CAPTURE_ACTIVE_KEY]);
  } catch {
    return false;
  }
}

export function writeRhythmNativeCaptureActive(active: boolean): void {
  try {
    (window as any)[NATIVE_CAPTURE_ACTIVE_KEY] = active;
  } catch {
    // ignore
  }
}

export function markRhythmNativeCaptureStarted(): void {
  writeRhythmNativeCaptureActive(true);
}

/** 外部 STOP_CAPTURE（退出律动/点「是」）后须清掉跟踪，否则误判仍在采集而跳过 START */
export function resetRhythmNativeCaptureTracking(): void {
  writeRhythmNativeCaptureActive(false);
  try {
    delete (window as any)[LAST_START_CAPTURE_SENT_AT_KEY];
  } catch {
    // ignore
  }
}

export function readRhythmLastStartCaptureSentAt(): number {
  try {
    return Number((window as any)[LAST_START_CAPTURE_SENT_AT_KEY] ?? 0);
  } catch {
    return 0;
  }
}

export function writeRhythmLastStartCaptureSentAt(at: number): void {
  try {
    (window as any)[LAST_START_CAPTURE_SENT_AT_KEY] = at;
  } catch {
    // ignore
  }
}
